import React, { FC, useMemo } from 'react';
import { CostCodeItemProps } from './types';
import { Box, Text } from '@bechtel/gds';
import { forEach, indexOf, map } from 'lodash';
import { TimesheetHourCode } from './hour-code';
import { Scalars } from '@bechtel/types';
import { CostCodeHeader } from './header';
import { CostCodeHeaderTotal } from './header-total';
import { TotalCellStyled } from './header-total/styled';
import { TotalHeaderColumnStyled } from '~/detail/styled';
import { Trans } from '@lingui/macro';
import { CostCodeDetailStyled, StickyBoxStyled } from './styled';

export const CostCodeItem: FC<CostCodeItemProps> = ({
  timesheetCostCode,
  name,
  collapseAll,
  collapseList,
  setCollapseList,
  crewId,
  costCodeListRef,
  onCostCodeListScroll,
}) => {
  const costCodesTotalHours = useMemo(() => {
    const totalHours: Scalars['Float'][] = [];
    forEach(timesheetCostCode.hourCodeTimeEntry, (timesheetHourCode, hourCodeIndex) => {
      forEach(timesheetHourCode.timeEntries, (timeEntry, index) => {
        const hrs = timeEntry.hours ? timeEntry.hours : 0;
        if (hourCodeIndex == 0) totalHours.push(hrs);
        else totalHours[index] = totalHours[index] + hrs;
      });
    });
    return totalHours;
  }, [timesheetCostCode.hourCodeTimeEntry]);

  const isCollapsed = indexOf(collapseList, timesheetCostCode?.costCode?.id) >= 0;

  return (
    <Box flexDirection={{ sm: 'column' }} data-testid="cost-code-item">
      <CostCodeHeader
        timesheetCostCode={timesheetCostCode}
        crewId={crewId}
        formikFieldName={name}
        collapseAll={collapseAll}
        collapseList={collapseList}
        setCollapseList={(list) => setCollapseList(list)}
      />
      <CostCodeDetailStyled
        ref={(element) => costCodeListRef.current.push(element ? element : null)}
        onScroll={(e) => {
          onCostCodeListScroll(e);
        }}
      >
        {!isCollapsed && (
          <>
            <CostCodeHeaderTotal costCode={timesheetCostCode.costCode} totalHrs={costCodesTotalHours} />
            <TimesheetHourCode timesheetHourCodes={timesheetCostCode.hourCodeTimeEntry} name={name}></TimesheetHourCode>
          </>
        )}

        {isCollapsed && (
          <Box mt={{ sm: '300' }}>
            <StickyBoxStyled background="white">
              <TotalHeaderColumnStyled>
                <Box pr={{ sm: '400' }} py={{ sm: '500' }} flexGrow={{ sm: '1' }} justifyContent={{ sm: 'flex-end' }}>
                  <Text color="grey.1000" size="400" weight="500">
                    <Trans>Total</Trans>
                  </Text>
                </Box>
              </TotalHeaderColumnStyled>
            </StickyBoxStyled>
            <Box alignItems={{ sm: 'center' }} css={{ background: 'white' }} flexGrow={{ sm: 1 }}>
              {map(costCodesTotalHours, (totalHr) => {
                return (
                  <TotalCellStyled>
                    <Text color="grey.1000" size="300" weight="600" family="graphik">
                      {totalHr}
                    </Text>
                  </TotalCellStyled>
                );
              })}
            </Box>
          </Box>
        )}
      </CostCodeDetailStyled>
    </Box>
  );
};
